export const RESET_LOADING = "resetLoading";
export const SET_HAS_OPEN_MODAL = "setHasOpenModal";
export const SET_LOADING = "setLoading";
